// extracted by mini-css-extract-plugin
export default {"FollowButton":"FollowButton_FollowButton__-8jlc"};